import translate from '../translations.json';

export default class Geolocalisation {
    constructor() {
        this.maxRange = 2500;

        this.openForm();
        this.closeForm();
        this.closePopin();
        this.submitForm();

        this.lang = document.documentElement.lang;
        this.translations = translate;
        this.locations;

        // if(localStorage.getItem('kitchen') != 'true'){
        //     this.backup();

        //     localStorage.setItem('kitchen', true);
        // }

        const hctas = document.querySelectorAll('header .cta');
        Array.from(hctas).forEach( hcta => {
            hcta.addEventListener('click', () => {
                this.backup('uber');
            });
        });

        const liens = document.querySelectorAll('.home section .cta');
        if(liens.length > 0){
            liens.forEach((lien) => {
              lien.addEventListener('click', () => {
                const classe = lien.classList[1];
                  this.backup(classe);
              });
            });
        }
    }

    openForm() {
        const label = document.querySelectorAll('.form form label');
        Array.from(label).forEach( link => {
            link.addEventListener('click', function(){
                if(!this.parentElement.parentElement.classList.contains('top')){
                    this.style.display = 'none';
                } else {
                    document.querySelector('.overlay-header').style.display = 'block';
                }
                this.nextElementSibling.classList.add('visible');
            });

            link.addEventListener('touchstart', function(){
                if(!this.parentElement.parentElement.classList.contains('top')){
                    this.style.display = 'none';
                } else {
                    document.querySelector('.overlay-header').style.display = 'block';
                }
                this.nextElementSibling.classList.add('visible');
            });
        });
    }

    closeForm() {
        document.querySelector('.overlay-header').addEventListener('click', function(){
            document.querySelector('.overlay-header').style.display = 'none';
            document.querySelector('.form.top form fieldset.visible').classList.remove('visible');
        });
    }

    getLocations() {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                console.log( this.responseText );
            }
        };

        xhttp.open('GET', '/wp-json/acf/v3/kitchens', true);
        xhttp.send();
    }

    openResult(datas) {
        document.querySelector('.message .text-container').innerHTML = '';
        document.querySelector('.message').classList.add('open');
        document.querySelector('.overlay').style.display = 'block';

        document.querySelector('.message .text-container').innerHTML = '<p>Ciao ragazzi,<br />select the kitchen closest to you to get your delivery!</p>';

        datas.forEach( data => {
            let node = document.createElement('div');
            node.classList.add('restaurant');
            document.querySelector('.message .text-container').appendChild( node );

            let title = document.createElement('p');
            title.classList.add('title');
            let textTitle = document.createTextNode( data[0] );
            title.appendChild( textTitle );
            node.appendChild( title );

            let distance = document.createElement('p');
            let textDistance = document.createTextNode( data[1] );
            distance.appendChild( textDistance );
            node.appendChild( distance );

            let url = document.createElement('a');
            let textUrl = document.createTextNode( data[2][0] );
            url.href = data[2][1];
            url.setAttribute('target', '_blank');
            url.appendChild( textUrl );
            node.appendChild( url );
        });
    }

    closePopin() {
        const close = document.querySelector('.message .close');
        const overlay = document.querySelector('.overlay');

        close.addEventListener('click', function(){
            this.parentElement.classList.remove('open');
            overlay.style.display = 'none';
        });

        overlay.addEventListener('click', function(){
            document.querySelector('.message').classList.remove('open');
            this.style.display = 'none';
        });
    }

    submitForm() {
        const forms = document.querySelectorAll('.commande');
        Array.from(forms).forEach( form => {
            form.addEventListener('submit', e => {
                e.preventDefault();
                let address = `${form.querySelector('#rue').value} ${+ form.querySelector('#zip').value} ${form.querySelector('#ville').value}`;

                let geocoder = new google.maps.Geocoder();
                geocoder.geocode( { 'address': address}, (results, status) => {
                    if (status == 'OK') {
                        const lat = results[0].geometry.location.lat();
                        const lng = results[0].geometry.location.lng();

                        var xhttp = new XMLHttpRequest();
                        let that = this;
                        xhttp.onreadystatechange = function() {
                            if (this.readyState == 4 && this.status == 200) {
                                that.locations = JSON.parse(this.responseText);
                                that.getDistance( lat, lng );
                            }
                        };

                        xhttp.open('GET', '/wp-json/acf/v3/kitchens', true);
                        xhttp.send();
                    } else {
                      alert(this.translations[this.lang].error + status);
                    }
                });

                // VALEUR DE TEST
                // var xhttp = new XMLHttpRequest();
                // let that = this;
                // xhttp.onreadystatechange = function() {
                //     if (this.readyState == 4 && this.status == 200) {
                //         that.locations = JSON.parse(this.responseText);
                //         that.getDistance( 48.87322478320968, 2.4024231946870023 );
                //     }
                // };

                // xhttp.open('GET', '/wp-json/acf/v3/kitchens', true);
                // xhttp.send();
            });
        });
    }

    getDistance(lat, lng) {
        let restaurants = [];

        this.locations.forEach( location => {
            let distance = 0;

            const dLat = (location.acf.latitude - lat) / 180* Math.PI;
            const dLong = (location.acf.longitude - lng) / 180 * Math.PI;

            let a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
                        + Math.cos(lat / 180* Math.PI) * Math.cos(location.acf.latitude / 180* Math.PI) 
                        * Math.sin(dLong/2) * Math.sin(dLong/2);
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

            //Calculate radius of earth
            // For this you can assume any of the two points.
            const radiusE = 6378135; // Equatorial radius, in metres
            const radiusP = 6356750; // Polar Radius

            //Numerator part of function
            let nr = Math.pow(radiusE * radiusP * Math.cos(lat / 180 * Math.PI), 2);
            //Denominator part of the function
            let dr = Math.pow(radiusE * Math.cos(lat / 180 * Math.PI), 2)
                            + Math.pow(radiusP * Math.sin(lat / 180 * Math.PI), 2);
            let radius = Math.sqrt(nr / dr);

            //Calculate distance in meters.
            distance = radius * c;
            if(distance < this.maxRange){
                let cuisine = [location.acf.nom_de_la_cuisine, (distance/1000).toFixed(2) + 'km', [this.translations[this.lang].selectReastaurant, location.acf.lien]];
                restaurants.push(cuisine);
            }
        });

        let datas = [];
        if(restaurants.length > 0){
            restaurants.forEach( r => {
                datas.push( r );
            } );
        } else {
            datas.push( [this.translations[this.lang].errorTitle, this.translations[this.lang].errorMessage, [this.translations[this.lang].errorLinkText, '/infos/']] );
        }

        this.openResult( datas );
    }

    backup(get_delivery){
        document.querySelector('aside.message').classList.add('open');
        var xhttp = new XMLHttpRequest();
        let that = this;
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                that.locations = JSON.parse(this.responseText);

                let restaurants = [];

                that.locations.forEach( location => {
                    let cuisine;
                    if (get_delivery === 'uber') {
                      cuisine = [location.acf.nom_de_la_cuisine, '', [that.translations[that.lang].selectReastaurant, location.acf.lien]];
                    } else {
                      cuisine = [location.acf.nom_de_la_cuisine, '', [that.translations[that.lang].selectReastaurant, location.acf.lien_deliveroo]];
                    }
                    restaurants.push(cuisine);
                });

                let datas = [];
                if(restaurants.length > 0){
                    restaurants.forEach( r => {
                        datas.push( r );
                    } );
                }

                that.openResult( datas );
            }
        };

        xhttp.open('GET', '/wp-json/acf/v3/kitchens', true);
        xhttp.send();
    }
}